// extracted by mini-css-extract-plugin
export var featuredContentModule__cardImg = "featured-content-module-module--featured-content-module__card-img--d5a74";
export var featuredContentModule__cardImgCardStyle = "featured-content-module-module--featured-content-module__card-img--card-style--00176";
export var featuredContentModule__cardImgIcon = "featured-content-module-module--featured-content-module__card-img--icon--2c300";
export var featuredContentModule__cardImgSquareImg = "featured-content-module-module--featured-content-module__card-img--square-img--d4f9c";
export var mt0 = "featured-content-module-module--mt-0--533ce";
export var mt1 = "featured-content-module-module--mt-1--d5687";
export var mt2 = "featured-content-module-module--mt-2--2109c";
export var mt3 = "featured-content-module-module--mt-3--1d86e";
export var mt4 = "featured-content-module-module--mt-4--b50e8";
export var mt5 = "featured-content-module-module--mt-5--591fa";
export var mt6 = "featured-content-module-module--mt-6--f1969";